import React, { useState, useEffect } from 'react'
import {
  TextField,
  Button,
  Typography,
  Paper,
  InputLabel,
  FormControl,
  MenuItem,
  Select
} from '@material-ui/core'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { NumericFormat } from 'react-number-format'
import useStyles from './styles'
import 'react-datepicker/dist/react-datepicker.css'
import axios from 'axios'
import { Link, useNavigate, useLocation } from 'react-router-dom'

import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined'
import RemoveCircleOutlinedIcon from '@material-ui/icons/RemoveCircleOutlined'

import {
  API_URL,
  URL,
  AddColor,
  SelectCategory,
  AddCategory,
  Category,
  ColorCode,
  ColorCodeName,
  EnterColorCode,
  EnterVersion,
  EnterVolume,
  EnterColorCodeName,
  VehicleVersion,
  Total,
  Volume,
  Percent,
  Save,
  SelectType,
  Motor,
  Car,
  EditColor,
  UpdateSuccess,
  GoBack,
  Close
} from '../../constants/actionTypes'
import Autocomplete from '@mui/material/Autocomplete'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

import uuid from 'react-uuid'
const FormEditColorMixing = () => {
  // const navigate = useNavigate()
  const [open, setOpen] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const API = axios.create({
    baseURL: API_URL
  })
  let data = useLocation()
  const location = useLocation()
  const myQuery = location.search
  const id = myQuery.split('=')[1]
  const navigate = useNavigate()
  // const loginSuccess = JSON.parse(localStorage.getItem('colorMixing'))
  // if (!loginSuccess) {
  //   navigate(URL + '/')
  // }
  const [colorCodeInfoList, setColorCodeInfoList] = useState([
    { colorCode: '', colorName: '', percent: 0, volume: 0, total: 0 }
  ])
  const [listColorCode, setListColorCode] = useState([])
  const [value, setValue] = useState('')
  const [inputValue, setInputValue] = useState([])

  const [dataColors, setDataColors] = useState([])
  const [dataColorEdit, setDataColorEdit] = useState([])
  const [listCategory, setListCategory] = useState([])

  const [postData, setPostData] = useState({
    id: uuid(),
    type: '',
    category: '',
    addCategory: '',
    nameCode: '',
    colorCode: '',
    version: '',
    files: '',
    filesStatus: '',
    fileSize: '',
    volume: '',
    vehicleName: '',
    content: [],
    info: ''
  })

  const classes = useStyles()
  const updateJson = (dataColors, files) => {
    const formData = new FormData()
    if (files) {
      formData.append('files', files[0])
    }
    formData.append('data', JSON.stringify(dataColors))
    API.post('/newhipic/ColorMixing/updateColorMixing', formData, dataColors)
  }
  // const updateJson = (jsonData) => API.post('/ColorMixing/updateColorMixing', jsonData)
  const bytesToMegaBytes = (bytes) => bytes / 1024 ** 2

  const MultipleFileChange = (e) => {
    const { files } = e.target

    Array.from(files).forEach((file) => {
      const fileSize = bytesToMegaBytes(file.size)
      // console.log(fileSize + 'MB')
      if (fileSize < 10) {
        setPostData({
          ...postData,
          files: e.target.files,
          filesStatus: 'uploading',
          fileSize: ''
        })
      } else {
        e.target.value = null
        setPostData({
          ...postData,
          fileSize:
            'you must make sure the file size is less than or equal to 10MB.'
        })
      }
    })
  }
  const checkKeyDown = (e) => {
    if (e.key === 'Enter') {
      let t = e.target.id //.search('btnAddColorMixing')
      if (t === 'handleInfoColorCodeAdd') {
        handleInfoColorCodeAdd()
      } else {
        e.preventDefault()
      }
      //

      //}
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    let CategoryRight = ''
    if (postData.addCategory != '') {
      CategoryRight = postData.addCategory
    } else {
      CategoryRight = postData.category
    }

    let newDate = new Date()
    let date = newDate.getDate()
    let month = newDate.getMonth() + 1
    let year = newDate.getFullYear()

    const data = {
      id: postData.id,
      category: CategoryRight,
      nameCode: postData.nameCode,
      type: postData.type,
      colorCode: postData.colorCode.trim(),
      version: postData.version.trim(),
      files: postData.files,
      filesStatus: postData.filesStatus,
      fileSize: postData.fileSize,
      volume: postData.volume,
      vehicleName: postData.vehicleName.trim(),
      content: postData.content,
      info: postData.info,
      createDate: date + '-' + month + '-' + year
    }

    let checkColorCode = false
    dataColors.map((item) => {
      if (
        postData.colorCode.trim().toUpperCase() ===
          item.colorCode.toUpperCase() &&
        item.category === CategoryRight &&
        postData.id !== item.id
      ) {
        alert('Mã màu đã tồn tại vui lòng nhập mã màu khác')
        checkColorCode = true
      } else {
        return true
      }
    })
    if (checkColorCode === false) {
      const dataEdit = dataColors.filter((item) => item.id !== id)

      dataEdit.push(data)

      updateJson(dataEdit, postData.files)
      setOpen(true)
      setTimeout(() => {
        navigate(URL + '/dashboard')
      }, 3000)
    }
  }
  const handleInfoColorCodeChange = (e, newValue, index) => {
    let { name, value } = e.target

    const list = [...colorCodeInfoList]
    if (newValue !== '' && newValue !== null) {
      value = newValue
      if (value !== '') {
        list[index]['colorCode'] = value.toUpperCase()
      }
    }
    if (name == 'volume') {
      list[index]['volume'] = value
    }

    let nameCode = ''
    let volume = 0
    let total = 0

    listColorCode.forEach((element) => {
      let value1 = element.colorCode
      let value2 = value

      total = 0

      if (value1.toUpperCase() == value2.toUpperCase()) {
        nameCode = element.nameCode

        list[index]['colorName'] = nameCode
      }
    })
    list.forEach((item, index2) => {
      total = parseFloat(total) + parseFloat(item.volume)
      total = parseFloat(total).toFixed(2)
      list[index2]['total'] = total
    })
    //list[index]['total'] = total

    setColorCodeInfoList(list)
    setPostData({ ...postData, content: colorCodeInfoList })
  }
  const handleInfoColorCodeChange2 = (e, newValue, index) => {
    const list = [...inputValue]

    const newNumbers = [
      ...list.slice(0, index),
      newValue.toUpperCase(),
      ...list.slice(index)
    ]

    // list.splice(e.target.id, 0, newValue)
    // if (newValue !== '') {
    //   list.push(newValue)
    // }
    // console.log(list)

    // setInputValue(list)
  }
  const handleInfoColorCodeRemove = (index) => {
    let total = 0
    const list = [...colorCodeInfoList]
    list.splice(index, 1)

    list.forEach((item, index2) => {
      total = parseFloat(total) + parseFloat(item.volume)
      total = parseFloat(total).toFixed(2)
      list[index2]['total'] = total
    })

    setColorCodeInfoList(list)
    setPostData({ ...postData, content: list })
  }

  const handleInfoColorCodeAdd = () => {
    setColorCodeInfoList([
      ...colorCodeInfoList,
      { colorCode: '', colorName: '', percent: 0, volume: 0, total: 0 }
    ])
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setPostData({ ...postData, [name]: value })
  }

  const getColorById = async (id, dataEditColor) => {
    const dataEdit = dataEditColor.filter((item) => item.id == id)
    setColorCodeInfoList(dataEdit[0].content)
    console.log(dataEdit[0].files)
    setPostData({
      ...postData,

      id: dataEdit[0].id,
      type: dataEdit[0].type,
      category: dataEdit[0].category,
      createDate: dataEdit[0].createDate,
      info: dataEdit[0].info,
      nameCode: dataEdit[0].nameCode,
      colorCode: dataEdit[0].colorCode,
      vehicleName: dataEdit[0].vehicleName,
      version: dataEdit[0].version,
      files: dataEdit[0].files,
      volume: dataEdit[0].volume,
      content: dataEdit[0].content
    })
    // setDataColorEdit(dataEdit)
  }
  const getAllColorCode = async () => {
    let arrayData = []
    let arrayCategory = []
    let dataColorMixingPath = ''
    // if (location.state.rePrint) {
    dataColorMixingPath = `${API_URL}/uploadshipic/src3/dataListColorHipic.json`
    axios
      .get(dataColorMixingPath, {
        crossdomain: true
      })
      .then((res) => {
        const dataColorMixing = res.data
        dataColorMixing.map((items) => {
          arrayData.push({
            id: items.id,
            colorCode: items.colorCode,
            nameCode: items.nameCode,
            volume: items.volume
          })
        })

        setListColorCode(arrayData)
        //  getColorById(id, arrayData)
      })
      .catch((error) => {
        console.log(error)
      })
  }
  const getAllColors = async () => {
    let arrayData = []
    let arrayCategory = []
    let dataColorMixingPath = ''
    // if (location.state.rePrint) {
    dataColorMixingPath = `${API_URL}/uploadshipic/src3/dataColorMixingHipic.json`
    axios
      .get(dataColorMixingPath, {
        crossdomain: true
      })
      .then((res) => {
        const dataColorMixing = res.data

        dataColorMixing.map((items) => {
          arrayCategory.push(items.category)
        })
        dataColorMixing.map((items) => {
          arrayData.push({
            id: items.id,
            type: items.type,
            category: items.category,
            colorCode: items.colorCode,
            nameCode: items.nameCode,
            vehicleName: items.vehicleName,
            content: items.content,
            info: items.info,
            version: items.version,
            files: items.files,
            volume: items.volume,
            createDate: items.createDate
          })
        })

        const namesArr = arrayCategory.filter(function (elem, pos) {
          return arrayCategory.indexOf(elem) == pos
        })
        setListCategory(namesArr)
        setDataColors(arrayData)

        getColorById(id, arrayData)
      })
      .catch((error) => console.log(error))
  }
  useEffect(() => {
    // if (!loginSuccess) {
    //   navigate(URL + '/login')
    // } else {

    getAllColors()
    getAllColorCode()
    //}
  }, [])

  return (
    <Paper className={classes.paper}>
      <div
        className='moreButton'
        style={{
          marginTop: '10px',
          display: 'flex',
          width: '100%',
          marginBottom: '15px'
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Link
            to={{
              pathname: URL + '/dashboard',
              state: { fromDashboard: true }
            }}
          >
            <Button
              style={{ marginLeft: '15px' }}
              className={classes.buttonLink}
              type='button'
            >
              {GoBack}
            </Button>
          </Link>
        </div>
        <div style={{ flexGrow: 9, textAlign: 'center' }}>
          <Typography
            variant='h6'
            style={{
              fontWeight: '700',
              fontSize: '25px',
              color: '#fff',
              textShadow: '1px 1px 1px #000'
            }}
          >
            {EditColor}
          </Typography>
        </div>
      </div>

      <form
        encType='multipart/form-data'
        autoComplete='off'
        noValidate
        onKeyDown={(e) => checkKeyDown(e)}
        className={`${classes.root} ${classes.form}`}
        onSubmit={handleSubmit}
        style={{ minHeight: '465px' }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <div className={classes.viewColorLeft} style={{ paddingTop: 0 }}>
                <div className='wrapSelect'>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    style={{ marginTop: '0px' }}
                  >
                    <InputLabel id='demo-simple-select-label'>
                      {SelectType} *
                    </InputLabel>

                    <Select
                      labelId='demo-simple-select-label'
                      id='demo-simple-select'
                      value={postData.type}
                      label={SelectType}
                      required
                      // error={postData.Location == '' ? 'error' : null}
                      onChange={(e) =>
                        setPostData({
                          ...postData,
                          type: e.target.value
                        })
                      }
                    >
                      <MenuItem key={'typelo'} value=''>
                        {SelectType}
                      </MenuItem>

                      <MenuItem key={'Carlo'} value='car'>
                        {Car}
                      </MenuItem>
                      <MenuItem key={'Motorlo'} value='motor'>
                        {Motor}
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel id='demo-simple-select-label'>
                      {SelectCategory} *
                    </InputLabel>

                    <Select
                      labelId='demo-simple-select-label'
                      id='demo-simple-select'
                      value={postData.category}
                      label={SelectCategory}
                      required
                      // error={postData.Location == '' ? 'error' : null}
                      onChange={(e) =>
                        setPostData({
                          ...postData,
                          category: e.target.value
                        })
                      }
                    >
                      <MenuItem key={'lo'} value=''>
                        {SelectCategory}
                      </MenuItem>
                      {listCategory.map((item, index) => (
                        <MenuItem key={item + index + 'lo'} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                      <MenuItem key={'addCategorylo'} value='addCategory'>
                        {AddCategory}
                      </MenuItem>
                    </Select>
                  </FormControl>
                  {postData.category === 'addCategory' ? (
                    <FormControl fullWidth className={classes.formControl}>
                      <TextField
                        className={classes.fileInput}
                        name='addCategory'
                        variant='outlined'
                        label={Category}
                        fullWidth
                        value={postData.addCategory || ''}
                        onChange={(e) => handleChange(e)}
                      />
                    </FormControl>
                  ) : (
                    ''
                  )}
                </div>
                <div className='wrapInput'>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      className={classes.fileInput}
                      name='colorCode'
                      variant='outlined'
                      label={EnterColorCode}
                      fullWidth
                      value={postData.colorCode || ''}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormControl>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      className={classes.fileInput}
                      name='nameCode'
                      variant='outlined'
                      label={EnterColorCodeName}
                      fullWidth
                      value={postData.nameCode || ''}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      className={classes.fileInput}
                      name='vehicleName'
                      variant='outlined'
                      label={VehicleVersion}
                      fullWidth
                      value={postData.vehicleName || ''}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormControl>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    style={{ position: 'relative', overflow: 'hidden' }}
                  >
                    <input
                      type='file'
                      className={classes.fileInput}
                      name='files'
                      onChange={(e) => MultipleFileChange(e)}
                    />
                    {postData && postData.files ? (
                      <img
                        src={API_URL + '/' + postData.files}
                        style={{ marginTop: '10px', maxWidth: '100%' }}
                      />
                    ) : (
                      ''
                    )}
                  </FormControl>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <div
                className={classes.displayResult}
                style={{ overflowX: 'scroll' }}
              >
                <div className='wrapInput'>
                  <FormControl className={classes.formControl} fullWidth>
                    {colorCodeInfoList.map((singleColorCode, index) => (
                      <div
                        style={{ marginBottom: '10px', display: 'flex' }}
                        key={index}
                        className={classes.phoneNumberGroup}
                      >
                        <div className={classes.firstDivision}>
                          <Autocomplete
                            freeSolo
                            disableClearable
                            options={listColorCode.map(
                              (option) => option.colorCode
                            )}
                            value={singleColorCode.colorCode}
                            key={singleColorCode.colorCode}
                            onChange={(event: any, newValue: string | null) => {
                              handleInfoColorCodeChange(event, newValue, index)
                            }}
                            inputValue={inputValue[index]}
                            onInputChange={(event, newInputValue, index) => {
                              // setInputValue(newInputValue)
                              // console.log(inputValue)
                              handleInfoColorCodeChange2(
                                event,
                                newInputValue,
                                index
                              )
                            }}
                            // value={singleColorCode.colorCode}
                            //onChange={(e) => handleInfoColorCodeChange(e, index)}

                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: '133px',
                                  flexGrow: 1,
                                  padding: '2px 0px'
                                }}
                                name='colorCode'
                                label={ColorCode}
                                {...params}
                                slotProps={{
                                  input: {
                                    ...params.InputProps,
                                    type: 'search'
                                  }
                                }}
                                variant='outlined'
                                fullWidth
                                className={classes.fileInputColorCode}
                              />
                            )}
                          ></Autocomplete>

                          <TextField
                            style={{ width: '250px', flexGrow: 5 }}
                            className={classes.fileInputName}
                            name='colorName'
                            variant='outlined'
                            disabled
                            label={ColorCodeName}
                            fullWidth
                            value={singleColorCode.colorName}
                            onChange={(e) =>
                              handleInfoColorCodeChange(e, index)
                            }
                          />

                          <NumericFormat
                            style={{ width: '100px', flexGrow: 1 }}
                            className={classes.fileInputVolume}
                            name='volume'
                            variant='outlined'
                            label={Volume}
                            value={singleColorCode.volume}
                            onChange={(e) =>
                              handleInfoColorCodeChange(e, '', index)
                            }
                            customInput={TextField}
                            valueIsNumericString
                          />

                          <TextField
                            className={classes.fileInputTotal}
                            style={{ width: '100px', flexGrow: 1 }}
                            name='total'
                            variant='outlined'
                            label={Total}
                            fullWidth
                            disabled
                            value={singleColorCode.total}
                            onChange={(e) =>
                              handleInfoColorCodeChange(e, index)
                            }
                          />
                          <div style={{ flexGrow: 1 }}>
                            {colorCodeInfoList.length - 1 === index &&
                              colorCodeInfoList.length < 20 && (
                                <button
                                  type='button'
                                  id='handleInfoColorCodeAdd'
                                  onClick={handleInfoColorCodeAdd}
                                  className={classes.addBtn}
                                >
                                  <span>
                                    <AddCircleOutlinedIcon
                                      style={{ color: '#fff' }}
                                    />
                                  </span>
                                </button>
                              )}

                            <div className={classes.secondDivision}>
                              {colorCodeInfoList.length !== 1 && (
                                <button
                                  type='button'
                                  onClick={() =>
                                    handleInfoColorCodeRemove(index)
                                  }
                                  className={classes.removeBtn}
                                >
                                  <span>
                                    <RemoveCircleOutlinedIcon
                                      style={{ color: '#fff' }}
                                    />
                                  </span>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </FormControl>

                  <FormControl className={classes.formControl} fullWidth>
                    <Button
                      style={{ maxWidth: '200px', margin: '0 auto' }}
                      className={classes.buttonSubmit}
                      variant='contained'
                      color='primary'
                      size='large'
                      id='btnAddColorMixing'
                      type='submit'
                      fullWidth
                    >
                      {Save}
                    </Button>
                  </FormControl>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </form>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {UpdateSuccess}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{Close}</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  )
}

export default FormEditColorMixing
